module.exports = __webpack_public_path__ + "img/ic_32_register_mail-active.54f153aa.svg";